import apiClient from "./apiClient"

export interface PortalSession {
  id: string
  title: string
  pageUrl: string
  updatedAt: string
  answerCount: number
}
interface AnswerValue {
  answers: string[]
  otherAnswer?: string | null
  confidenceScore?: number | null
  citations?: { file: string; page?: number | null }[]
}
export interface PortalDetail {
  id: string
  answers: {
    id: string
    question: string
    generated: AnswerValue
    submitted: AnswerValue | null
    submittedAt: string | null
  }[]
}
export const answerText = (value: AnswerValue) =>
  [...(value.answers || []), value.otherAnswer || ""].filter(Boolean).join("\n")

export async function getPortalSessions(search: string, offset: number) {
  const response = await apiClient.get<PortalSession[]>("/extension/history", {
    params: { search, offset, limit: 50 },
  })
  return response.data
}
export async function getPortalDetail(id: string) {
  return (await apiClient.get<PortalDetail>(`/extension/history/${id}`)).data
}
